import React, { useRef, useMemo } from "react";
import { NavLink, Redirect, Route, Switch, useParams } from 'react-router-dom';
import PrivateRoute from "@common/components/route/PrivateRoute";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import { RentCabinetOverviewPage, CabinetOverviewPage } from "@icoach/rentCabinet";
import RentCabinetDialogBox from "@icoach/rentCabinet/dialog/RentCabinetDialogBox";
import TabsCardLayout from "@icoach/components/layout/TabsCardLayout";
import useTabState from "@util/hook/useTabState";

const tabContentType = {
	DOCUMENT: "document",
	OVERVIEW: "overview",
};

const RentCabinetPage = () => {
	const { subTabs = tabContentType.DOCUMENT } = useParams();
	const { activeTab, handleTabChange } = useTabState(subTabs);
	const dialogRef = useRef(null);
	const refreshRef = useRef(null);

	const tabsData = useMemo(
		() => {
			return [
				{
					label: "租約管理",
					value: tabContentType.DOCUMENT,
					component: NavLink,
					to: CLUB_MEMBERS_ROUTER.CABINET.GET_TABS_PATH("document"),
				},
				{
					label: "置物櫃管理",
					value: tabContentType.OVERVIEW,
					component: NavLink,
					to: CLUB_MEMBERS_ROUTER.CABINET.GET_TABS_PATH("overview"),
				},
			];
		},
		// eslint-disable-next-line
		[]
	);
    
	const actionsData = useMemo(
		() => {
			const actionMap = {
				[tabContentType.DOCUMENT]: [{ label: "新增租約", component: NavLink, to: CLUB_MEMBERS_ROUTER.CABINET.GET_CONTRACT_RENTCABINETID_PATH("contract", 0) }],
				[tabContentType.OVERVIEW]: [
					{
						label: "新增置物櫃",
						onClick: () => dialogRef.current && dialogRef.current.openCreateCabinetDialog({}, refreshRef.current),
					},
					{
						label: "批次新增",
						onClick: () => dialogRef.current && dialogRef.current.openImportCabinetDialog({}, refreshRef.current),
					},
				],
			};
			return actionMap[activeTab];
		},
		// eslint-disable-next-line
		[activeTab]
	);

	return (
		<TabsCardLayout tabs={tabsData} activeTab={activeTab} onTabChange={handleTabChange} tabsContent={{ className: "py-3 px-4" }} actions={actionsData}>
			<Switch>
				<PrivateRoute key="置物櫃管理" exact={true} path={CLUB_MEMBERS_ROUTER.CABINET.GET_TABS_PATH("overview")} as={CabinetOverviewPage} dialogRef={dialogRef} refreshRef={refreshRef} />
				<PrivateRoute key="租約管理" exact={true} path={CLUB_MEMBERS_ROUTER.CABINET.GET_TABS_PATH("document")} as={RentCabinetOverviewPage} dialogRef={dialogRef} refreshRef={refreshRef} />
				<Route path="/">
					<Redirect to={CLUB_MEMBERS_ROUTER.CABINET.GET_TABS_PATH('document')} />
				</Route>
			</Switch>
			<RentCabinetDialogBox ref={dialogRef} />
		</TabsCardLayout>
	);
};

export default RentCabinetPage;
